import axios from "axios";
import API_BASE_URL from "./config";  // مثلاً "https://localhost:44315/api"

const instance = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" }
});

instance.interceptors.request.use(cfg => {
  const t = localStorage.getItem("token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export default instance;
